import CmsUsersPage from './CmsUsersPage';

export default CmsUsersPage;
